import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionLoaderService {

  constructor() { }

  private permissionApiCallState: Subject<boolean> = new Subject<boolean>();

  // null until the first load starts.
  private current: boolean | null = null;

  // Listeners reload on every "done", so only changes are announced.
  setState(state: boolean) {
    if (state === this.current) {
      return;
    }
    this.current = state;
    this.permissionApiCallState.next(state);
  }

  getState(): Observable<boolean> {
    return this.permissionApiCallState.asObservable();
  }

  get isLoaded(): boolean {
    return this.current === false;
  }
}
